<template>
  <div
    class="press-material-list-wrapper"
    data-test-id="component-press-material-list"
  >
    <div
      class="flex relative flex-wrap  -mx-tiny"
      data-test-id="block-press-material-list-list"
    >
      <div
        v-for="(material, index) in items"
        :key="index"
        class="block w-full md:w-1/2 px-standart"
        :data-test-id="`block-press-material-list-list-item-${index}`"
      >
        <PressMaterialListItem
          :item="material"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
